/** Platform roles (CFG-006, ADR-0004). Stored in Firebase custom claims; set by backend only. */
export const ROLES = [
    "super_admin",
    "org_admin",
    "doctor",
    "radiologist",
    "technician",
    "receptionist",
    "ai_reviewer",
    "patient",
];
export const ROLE_METADATA = {
    super_admin: {
        label: "Platform administrator",
        description: "Operates the platform and organizations. No clinical data access by default.",
        clinical: false,
        requiresMfa: false,
    },
    org_admin: {
        label: "Organization administrator",
        description: "Manages users and settings within one organization. No clinical data access.",
        clinical: false,
        requiresMfa: false,
    },
    doctor: {
        label: "Doctor",
        description: "Treating clinician: patients, encounters, labs, reports.",
        clinical: true,
        requiresMfa: false,
    },
    radiologist: {
        label: "Radiologist",
        description: "Reads imaging studies, reviews AI findings, signs imaging reports.",
        clinical: true,
        requiresMfa: false,
    },
    technician: {
        label: "Sonography technician",
        description: "Acquires and uploads imaging studies.",
        clinical: true,
        requiresMfa: false,
    },
    receptionist: {
        label: "Front desk",
        description: "Registers patients and manages appointments. No access to imaging or reports.",
        clinical: true,
        requiresMfa: false,
    },
    ai_reviewer: {
        label: "AI reviewer",
        description: "Reviews and annotates AI output for quality. Cannot sign clinical reports.",
        clinical: true,
        requiresMfa: false,
    },
    patient: {
        label: "Patient",
        description: "Views their own records and signed reports via the patient portal.",
        clinical: false,
        requiresMfa: false,
    },
};
export function isRole(value) {
    return typeof value === "string" && ROLES.includes(value);
}
//# sourceMappingURL=roles.js.map